"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var TrackLimitNumbers_1 = require("./TrackLimitNumbers");
var TrackLimit = function (props) {
    return (React.createElement("div", { className: "track-limit flex-column" },
        React.createElement(TrackLimitNumbers_1.default, { activeDebts: props.activeDebts, createableDebts: props.createableDebts, periodEnd: props.periodEnd })));
};
exports.default = TrackLimit;
